import React from "react";
import { Box, Paper, Typography, Button, Container } from "@mui/material";
import { ArrowBack as ArrowBackIcon, Print as PrintIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import FormGuidelines from "../../components/FormBuilder/FormGuidelines";
import "./FormGuidelinesPage.scss";

const FormGuidelinesPage = () => {
  const navigate = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box className="form-guidelines-page">
      {/* Header */}
      <Paper
        className="page-header"
        elevation={3}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
          color: 'white',
          p: 3,
          mb: 3,
          borderRadius: 2
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 2 }}>
              🔑 Form Builder Guidelines
            </Typography>
            <Button
              startIcon={<PrintIcon />}
              onClick={handlePrint}
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', borderColor: 'white' }
              }}
            >
              Print
            </Button>
          </Box>


        </Container>
      </Paper>

      {/* Content */}
      <Container maxWidth="lg" className="guidelines-content">
        <FormGuidelines compact={false} />

        {/* Footer */}
        <Paper
          elevation={0}
          sx={{
            mt: 4,
            p: 3,
            textAlign: 'center',
            bgcolor: '#f5f5f5',
            borderRadius: 2
          }}
        >
          {/* <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>
            📖 Keep this page bookmarked for easy reference while building forms
          </Typography> */}
          <Typography variant="body2" sx={{ color: '#999' }}>
            Form Builder Guidelines - v1.0
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default FormGuidelinesPage;
